import { createMutationHelper } from '@utils/swr'
import { type CampaignTokenLoginRequest } from '../types/apiRequest'
import { type CampaignTokenLoginResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<FortuneApis['post']['wpTokenLogin'], CampaignTokenLoginResponse, CampaignTokenLoginRequest, { code: string }>({
  client: 'fortune',
  key: params => params ? `/campaigns/${params.code}/member/wp_login_url` : null,
  fetcher: (_url, { arg, client }) => {
    const { code, redirect_path } = arg
    if (!code) {
      throw new Error('Campaign code is required')
    }
    return client.post(`/campaigns/${code}/member/wp_login_url?redirect_path=${redirect_path}`)
  },
})

export const useApiCampaignTokenLogin = useMutation
